import { Card, Stack } from "react-bootstrap";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import LoadingIndicator from "../LoadingIndicator";
import ErrorResponse from "../ErrorResponse";
import RATooltip from "../RATooltip";
import { doughnutOptions, htmlLegendPlugin } from "../chartOptions";

ChartJS.register(ArcElement, Tooltip, Legend, annotationPlugin, ChartDataLabels);

export default function ListenerGroupsCard({ data, loading, error, isFullDaypart = true }) {
    const chartData = useMemo(() => {
        if (data) {
            return {
                labels: ["Light", "Moderate", "Heavy"],
                datasets: [
                    {
                        label: "Time Frame",
                        type: "doughnut",
                        backgroundColor: ["#7BA7CC", "#396A93", "#284B67"],
                        data: [data.light.time_frame, data.moderate.time_frame, data.heavy.time_frame],
                        datalabels: {
                            anchor: "end",
                        },
                    },
                    {
                        label: "Average",
                        type: "doughnut",
                        backgroundColor: ["#7BA7CC", "#396A93", "#284B67"],
                        data: [data.light.average, data.moderate.average, data.heavy.average],
                        datalabels: {
                            anchor: "start",
                        },
                    },
                ],
            };
        }
    }, [data]);

    return (
        <Card>
            <Card.Header className={`d-flex align-items-center px-2 ${isFullDaypart ? "" : "health-daypart-header"}`}>
                <span className={`offset-1 flex-grow-1`}>Listener Groups</span>
                <div className="col-1 d-flex justify-content-end">
                    <RATooltip size={20}>
                        <Stack gap={2}>
                            <span>Percentage of total sessions by listeners group.</span>
                            <span>
                                <b>Heavy</b>- 7x a week.
                            </span>
                            <span>
                                <b>Moderate</b>- 4-6x a week.
                            </span>
                            <span>
                                <b>Light</b>- 1-3x a week.
                            </span>
                        </Stack>
                    </RATooltip>
                </div>
            </Card.Header>
            <Card.Body className="py-0 card-health-chart d-flex">
                {loading ? (
                    <LoadingIndicator width={85} />
                ) : error ? (
                    <ErrorResponse errorCode={error} />
                ) : (
                    <>
                        <Stack id="legend-container-listener-groups" className="py-3"></Stack>
                        <Doughnut data={chartData} options={doughnutOptions("legend-container-listener-groups")} plugins={[htmlLegendPlugin]} />
                    </>
                )}
            </Card.Body>
        </Card>
    );
}
